import PQueue from 'p-queue'
import _ from 'lodash'
import safeAwait from '../../../../lib/safeAwait'
import errorHelper, { httpHandler } from '../../../../lib/errorHelper'

const batchProposals = async (actions, paramsList) => {
  // chrome maximum parallel connections 6
  // 保留 1 個萬一同時需要發其他請求才不會被卡住
  const queue = new PQueue({ concurrency: 5 })
  const controller = new AbortController()
  const getTasks = ({ signal }) => _.map(paramsList, (params) => {
    return async () => {
      if (signal && signal.aborted) {
        const error = new Error('取消修改')
        return [{ message: error.message, params, error }]
      }
      const [error, payload] = await safeAwait(
        params.id
          ? actions.updateProposals(params).then(httpHandler)
          : actions.createProposals(params).then(httpHandler)
      )
      const errorMessage = errorHelper.parseErrorMessage(error)
      if (errorMessage) {
        return [{ message: errorMessage, params, error }]
      }

      return [undefined, payload]
    }
  })
  const batchProposals = await queue.addAll(getTasks(controller))
  return batchProposals
}

export const BATCH_STATUS = {
  REJECTED: 'rejected',
  FULFILLED: 'fulfilled',
  PENDING: 'pending'
}

/**
 * 產生送出提案，並透過 setState 馬上回存結果，達成及時更新每筆提案狀態的效果
 * @param {Object} actions
 * @param {Object} params
 * @param {number} index - 提案的索引
 * @param {Function} setState - 回存結果的函式
 * @param {Object} signal - 用來取消的 signal
 * @returns {Function} 提案的回傳結果
 */
export const batchProposalsAndUpdateStatus = async (actions, params, index, setState, signal) => {
  // Check if the operation is aborted before starting
  if (signal && signal.aborted) {
    return
  }
  // Set pending status
  setState((prevState) => ({ ...prevState, [index]: { status: BATCH_STATUS.PENDING, params } }))

  const [error, payload] = await safeAwait(
    params.id
      ? actions.updateProposals(params).then(httpHandler)
      : actions.createProposals(params).then(httpHandler)
  )
  const errorMessage = errorHelper.parseErrorMessage(error)
  if (errorMessage) {
    // Handle error immediately
    setState((prevState) => ({ ...prevState, [index]: { status: BATCH_STATUS.REJECTED, message: errorMessage, params, error } }))
    return [{ message: errorMessage, params, error }]
  }

  // Handle success immediately
  setState((prevState) => ({ ...prevState, [index]: { status: BATCH_STATUS.FULFILLED, payload } }))
  return [undefined, payload]
}

export default batchProposals
